// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"154":"2bba8c3046f6f8ca0d36","264":"4c51160b72e3977e7003","293":"28eebc80aefde65bba5e","700":"ddde63e3dbfcbbb6db76","829":"1c5c1b3eb7d84f83660a","858":"0a1c7c6166c8a43b1389","938":"4a13a8b90bf3101a3f66"}[chunkId] + ".js";
};